function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "icon-key-plus",
  transform: "translate(-1191 -176)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_2137",
  "data-name": "Ret\\xE2ngulo 2137",
  width: 13,
  height: 13,
  transform: "translate(1191 176)",
  fill: "red",
  opacity: 0
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_4285",
  "data-name": "Caminho 4285",
  d: "M5.65,3A2.546,2.546,0,0,1,8.123,4.767H13.6V6.533H11.833V8.3H10.067V6.533H8.123A2.6,2.6,0,0,1,5.65,8.3a2.65,2.65,0,0,1,0-5.3m0,1.767a.883.883,0,1,0,.883.883.906.906,0,0,0-.883-.883m.294,6.478H7.711V9.478H8.889v1.767h1.767v1.178H8.889v1.767H7.711V12.422H5.944Z",
  transform: "translate(1189.2 173.906)"
}));

function SvgIconKeyPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKeyPlus);
export default __webpack_public_path__ + "static/media/icon-key-plus.620ba7e7.svg";
export { ForwardRef as ReactComponent };